import snapshot from 'utils/pdfOptionsCatalog.json';
const options = snapshot.groups.flatMap(group => group.options);
export const PRINT_DETAIL_FIELD_OPTIONS = options
  .find(option => option.key === 'visible_detail_fields')
  .choices.map(choice => ({ key: choice.value, label: choice.label }));
export const PRINT_OVERTIME_SLOT_OPTIONS = options
  .find(option => option.key === 'visible_overtime_slots')
  .choices.map(choice => ({
    slot: choice.value,
    defaultLabel: choice.label.replace(/^OT\d — /, ''),
  }));

export const DEFAULT_PRINT_DETAIL_FIELDS = PRINT_DETAIL_FIELD_OPTIONS.reduce(
  (fields, { key }) => ({ ...fields, [key]: true }),
  {}
);

export const DEFAULT_PRINT_OVERTIME_SLOTS = PRINT_OVERTIME_SLOT_OPTIONS.reduce(
  (slots, { slot }) => ({ ...slots, [slot]: false }),
  {}
);

export const filterPrintDetailColumns = (
  columns,
  visibleFields,
  visibleOvertimeSlots
) =>
  (columns || []).filter(
    column =>
      visibleFields?.[column.key] !== false &&
      (visibleOvertimeSlots == null ||
        !column.overtimeSlot ||
        visibleOvertimeSlots[column.overtimeSlot])
  );

export const getVisiblePrintDetailFieldKeys = visibleFields =>
  PRINT_DETAIL_FIELD_OPTIONS.filter(
    ({ key }) => visibleFields?.[key] !== false
  ).map(({ key }) => key);

export const getVisiblePrintOvertimeSlots = visibleOvertimeSlots =>
  PRINT_OVERTIME_SLOT_OPTIONS.filter(
    ({ slot }) => visibleOvertimeSlots?.[slot]
  ).map(({ slot }) => slot);

const PRINT_DETAIL_COLUMN_WEIGHTS = {
  account_number: 0.9,
  item: 2.2,
  tags: 1.5,
  quantity: 0.8,
  unit: 1,
  rate: 1,
  currency: 0.9,
  multiplier: 0.7,
  multiplier_unit: 1,
  item_total: 1.2,
  fringes: 1.2,
  column_total: 1.2,
  actual: 1.1,
  comment: 1.8,
};

export const getPrintDetailColumnWidths = columns => {
  const weights = (columns || []).map(column => {
    if (column.isOvertime) return 0.8;
    if (column.isOvertimeRate) return 1;
    return PRINT_DETAIL_COLUMN_WEIGHTS[column.key] || 1;
  });
  const totalWeight = weights.reduce((total, weight) => total + weight, 0);

  if (!totalWeight) return [];
  return weights.map(weight => `${(weight / totalWeight) * 100}%`);
};
